
import Vue from "vue";

export default Vue.extend({
  props: {
    fillClass: {
      type: String,
      default: "fill-black",
    },
  },
});
